// utils
import { getAppointedDate } from "src/utils/get-date";

// ----------------------------------------------------------------------


export function getWeightByUnit(weight, unit) {
    let result = "";

    switch (unit) {
        case "lb":
            result = weight;
            break;
        case "oz":
            result = Math.round(weight * 6.25) / 100;
            break;
        case "g":
            result = Math.round(weight * 0.220462) / 100;
            break;
        case "kg":
            result = Math.round(weight * 220.462) / 100;
            break;
        default:
            result = weight;
            break;
    }

    return result;
}

export function getParcel(form, data) {
    let parcel;

    if (data) {
        if (data?.type === "my_package") {
            parcel = {
                package_id: data?.id,
                type: "my_package"
            };
        } else {
            parcel = {
                carrier_package_id: data?.id ?? "",
                weight: form?.weight || 0,
                weight_unit: form?.weight_unit,
                type: "predefined"
            };
        }
    } else {
        parcel = {
            length: form.length || 0,
            width: form.width || 0,
            height: form.height || 0,
            package_category: form.package_id === 1 ? "box_or_thick_parcel" : "poly_mailer",
            package_type: "custom",
            dimension_unit: form.dimension_unit,
            weight: form.weight || 0,
            weight_unit: form.weight_unit,
            type: "custom"
        };
    }

    return parcel;
}

// ----------------------------------------------------------------------

export const getNotificationListBody = filter => {
    if (!filter) return undefined;

    const request = JSON.parse(JSON.stringify(filter));

    if (!request.content_type) {
        delete request.content_type;
    }

    return request;
};

export const getAddressListBody = filter => {
    if (!filter) return undefined;

    const request = JSON.parse(JSON.stringify(filter));

    if (request?.search_category) {
        switch (request?.search_category) {
            case "Name":
                request.name = request.keyword ? request.keyword : "";
                break;
            case "Phone":
                request.phone = request.keyword ? request.keyword : "";
                break;
            default:
                break;
        }
    }

    delete request.search_category;
    delete request.keyword;

    return request;
};

export const getOrderListBody = filter => {
    if (!filter) return undefined;

    const request = JSON.parse(JSON.stringify(filter));

    if (request?.date_selection && !request?.from_order_date && !request?.to_order_date) {
        const tempTime = getAppointedDate(request.date_selection);

        request.from_order_date = tempTime.startTime;
        request.to_order_date = tempTime.endTime;
    }

    if (request?.date_selection) {
        delete request.date_selection;
    }

    if (!request?.tag_ids || ( request?.tag_ids && request.tag_ids.length === 0 )) {
        delete request.tag_ids;
    } else {
        request.tag_ids = request.tag_ids.join(",");
    }

    if (request?.keyword) {
        request.hybrid = request.keyword;
    }

    if (!request?.filter_combined) {
        delete request.filter_combined;
    }

    if (!request?.filter_split) {
        delete request.filter_split;
    }

    if (request?.has_order_note !== true) {
        delete request.has_order_note;
    }

    request.page_no = request.page;

    delete request.keyword;
    delete request.total;
    delete request.page;

    return request;
};

// stores/:platform/install
export const getAddStoreBody = (request, storedData) => {
    const localRequest = { ...request };

    switch (localRequest.platform) {
        case "shopify":
            localRequest.platform = "shopify";
            localRequest.store_id = storedData?.store_id ?? null;
            localRequest.store_setting = {
                domain: ( localRequest?.shop ?? "" ).split(".")[ 0 ],
                store_id: storedData?.store_id ?? null
            };

            delete localRequest.shop;
            delete localRequest.hmac;
            delete localRequest.host;
            delete localRequest.timestamp;
            delete localRequest.state;

            break;
        case "wix":
            localRequest.platform = "wix";
            localRequest.store_setting = {
                token: localRequest?.token ?? ""
            };

            delete localRequest.token;

            break;
        case "shoplazza":
            localRequest.platform = "shoplazza";
            localRequest.store_setting = {
                store_name: ( localRequest?.shop ?? "" ).split(".")[ 0 ]
            };

            delete localRequest.hmac;
            delete localRequest.install_from;
            delete localRequest.shop;
            delete localRequest.store_id;

            break;
        default:
            break;
    }

    return localRequest;
};

// stores/:platform/authorized
export const getInstallStoreBody = (request, storedData) => {
    const localRequest = { ...request };

    switch (localRequest.platform) {
        case "shopify":
            localRequest.shop_origin = localRequest.shop;

            delete localRequest.shop;
            delete localRequest.hmac;
            delete localRequest.host;
            delete localRequest.timestamp;
            delete localRequest.state;

            break;
        case "wix":
            localRequest.instance_id = localRequest.instanceId;

            delete localRequest.instanceId;

            break;
        case "ebay":
            localRequest.platform = "ebay";
            localRequest.session_id = storedData?.session_id ?? "";

            delete localRequest.ebaytkn;
            delete localRequest.tknexp;
            delete localRequest.username;

            break;
        case "etsy":
            delete localRequest.state;

            break;
        case "shein":
            localRequest.temp_token = localRequest?.tempToken ?? "";

            delete localRequest.appid;
            delete localRequest.state;
            delete localRequest.tempToken;

            break;
        case "shein-sm":
            localRequest.temp_token = localRequest?.tempToken ?? "";

            delete localRequest.appid;
            delete localRequest.state;
            delete localRequest.tempToken;

            break;
        case "walmart-marketplace":
            localRequest.partner_id = localRequest?.sellerId ?? "";

            delete localRequest.clientId;
            delete localRequest.partnerType;
            delete localRequest.sellerId;
            delete localRequest.state;
            delete localRequest.type;

            break;
        case "shoplazza":
            localRequest.platform = "shoplazza";
            localRequest.store_name = ( localRequest?.shop ?? "" ).split(".")[ 0 ];
            localRequest.query_string = `code=${ localRequest.code }&shop=${ localRequest.shop }`;
            localRequest.temp_session_id = storedData?.temp_session_id;

            delete localRequest.shop;

            break;
        case "allvalue":
            localRequest.platform = "allvalue";

            break;
        default:
            break;
    }

    return localRequest;
};
